import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import AnimakitExpander from "animakit-expander";
import Media from 'react-media'

import classes from './Flight.scss';

import Spinner from '../../UI/Spinner/Spinner';
import Loader from '../../UI/Loader/Loader';

import FlightDetailsRoundTrip from '../FlightDetailsRoundTrip/FlightDetailsRoundTrip';

import FlightTupleHeader from '../TupleHeader/TupleHeader';
import FlightHeader from '../FlightHeader/FlightHeader';
import OneWayTuple from '../Tuple/Tuple';
import CalendarSmall from '../../CalendarSmall/CalendarSmall';
import OneWayClubbed from '../TupleClubbed/TupleClubbed';
import FlightRoundTrip from '../../../components/Flight/FlightTupleRoundTrip/FlightTupleRoundTrip';
import InternationaTupleRoundTrip from '../../../components/Flight/InternationalTupleRoundTrip/InternationalTupleRoundTrip';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Illustrations from '../../UI/Illustrations/Illustrations';
import errorImage from '../../../assets/images/no-flights-found.png';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Button from '../../UI/Button/Button';
import Filters from '../../Filters/Filters';

import * as stackFlightActions from '../../../store/actions/index';
import * as farePriceActions from '../../../store/actions/index';
import { List, AutoSizer, WindowScroller, CellMeasurer, CellMeasurerCache } from "react-virtualized";
import FlightHeaderQuickFilters from '../FlightHeader/FlightHeaderQuickFilters/FlightHeaderQuickFilters';

let _list;

class Flight extends Component {
    cache = new CellMeasurerCache({ fixedWidth: true, defaultHeight: 187 })

    _setListRef = ref => {
        _list = ref;
    };

    resizeAll = (index) => {
        this.cache.clearAll();
        _list.recomputeRowHeights();
    };

    proceedToBook = e => {
        e.stopPropagation();
        this.props.onClearPax();
        this.props.onSetStackFlight([this.props.intDepart[this.props.tupleIndex][0]], this.props.intDepart[this.props.tupleIndex][0].FD.O, this.props.date, this.props.intDepart[this.props.tupleIndex][0].xmlKey, this.props.intDepart[this.props.tupleIndex][0].ID, "onward");
        this.props.onSetStackFlight([this.props.intReturn[this.props.tupleIndex][0]], this.props.intReturn[this.props.tupleIndex][0].FD.O, this.props.date, this.props.intReturn[this.props.tupleIndex][0].xmlKey, this.props.intReturn[this.props.tupleIndex][0].ID, "return");
        let flightIdCSV = null;
        let flightCode = null;
        let supplierCode = null;
    
        const flightTotalPrice = Math.round(this.props.intDepart[this.props.tupleIndex][0].FD.O.revisedFareDetails.af);
        flightIdCSV = this.props.intDepart[this.props.tupleIndex][0].ID;
        flightCode = this.props.flightCode;
        supplierCode = this.props.intDepart[this.props.tupleIndex][0].xmlKey;
        
    
        const queryParams = [];
        queryParams.push('searchId=' + this.props.searchId);
        queryParams.push('msid=' + this.props.searchId);
        queryParams.push('mode=Instant');
        queryParams.push('bpc=true');
        queryParams.push('isSR=false');
        queryParams.push('flightIdCSV=' + flightIdCSV);
        queryParams.push('flightPrice=' + flightTotalPrice);
        queryParams.push('sc=' + supplierCode);
        queryParams.push('flightCode=' + flightCode);
        queryParams.push('isInt=' + true);
        const queryString = queryParams.join("&");
    
        this.props.history.push({
        //   pathname: "/reviews",
        pathname: "/reviews/details",
          search: "?" + queryString
        });
      };

    rowRenderer = ({index, parent, key, style}) => {
        return (
            <CellMeasurer 
                key={key}
                cache={this.cache}
                parent={parent}
                columnIndex={0}
                rowIndex={index}>
                <div style={style}>
                    <InternationaTupleRoundTrip 
                        intDepartFlights={this.props.intDepart[index]} 
                        intReturnFlights={this.props.intReturn[index]} 
                        tupleIndex={index} 
                        key={index}
                        resize={this.resizeAll} />
                </div>
            </CellMeasurer>
       );
    }

    render() {
    let oneWayDomesticFlights = null;
    let roundTripDomesticFlights = null;

    let oneWayInternationalFlights = null;
    let roundTripInternationalFlights = null;

    if (this.props.flightType === 'DOM') {
        if(this.props.type === "R") {
            roundTripDomesticFlights = <FlightRoundTrip departPrev={this.props.departPrev}
            departNext={this.props.departNext}
            returnPrev={this.props.returnPrev}
            returnNext={this.props.returnNext}/>;
        } else {
            oneWayDomesticFlights = this.props.domOneWayFlights.map((flight, index) => {
                    let tuple = null;
                    if (flight.length === 1) {
                        tuple = (
                            <div className={classes.ContainersSingle}
                            style={{ animationDelay: `${index * 0.4}s` }}
                            key={index}>
                                <OneWayTuple 
                                    type="oneWay"
                                    flightSchedule={flight[0].OD} 
                                    fareDetails={flight[0].FD.O} 
                                    supplierCode={flight[0].supplierCode}
                                    xmlKey={flight[0].xmlKey}
                                    flightId={flight[0].ID}
                                    index={index}
                                    key={index}
                                    scrollTop={this.props.scrollTop}
                                />
                            </div>
                        );
                    } else if (flight.length > 1) {
                        tuple = (
                            <div className={classes.ContainersClubbed}
                            style={{ animationDelay: `${index * 0.4}s` }}
                            key={index}>
                                <OneWayClubbed
                                    type="oneWay"
                                    flight={flight}
                                    flightSchedule={flight[0].OD}
                                    fareDetails={flight[0].FD.O}
                                    xmlKey={flight[0].xmlKey}
                                    index={index}
                                    key={index}
                                    date={this.props.departDate}
                                    scrollTop={this.props.scrollTop}
                                    airlineNames={this.props.airlineNames}
                                    />
                            </div>
                        ); 
                    }
                return tuple;
            });
        }
    } else if (this.props.flightType === 'INT') {
        if (this.props.type === 'R') {
            roundTripInternationalFlights = 
            <WindowScroller>
                {({height, isScrolling, onChildScroll, scrollTop, registerChild}) => (
                    <AutoSizer disableHeight>
                        {({width}) =>  {
                            return (
                                <List width={width}
                                    ref={this._setListRef}
                                    height={height}
                                    autoHeight
                                    isScrolling={isScrolling}
                                    onScroll={onChildScroll}
                                    rowRenderer={this.rowRenderer}
                                    rowCount={this.props.intDepart.length}
                                    scrollTop={scrollTop}
                                    deferredMeasurementCache={this.cache}
                                    rowHeight={this.cache.rowHeight}
                                    />
                                );
                            }}
                    </AutoSizer>   
                )}
            </WindowScroller>
        } else {
                        oneWayInternationalFlights = this.props.intOneWayFlights.map((flight, index) => {
                        let tuple = null;
                        if (flight.length === 1) {
                            tuple = (
                                <div className={classes.ContainersSingle}
                                style={{ animationDelay: `${index * 0.4}s` }}
                                key={index}>
                                    <OneWayTuple 
                                        type="oneWay"
                                        flightSchedule={flight[0].OD} 
                                        fareDetails={flight[0].FD.O} 
                                        supplierCode={flight[0].supplierCode}
                                        flightId={flight[0].ID}
                                        index={index}
                                        key={index}
                                        scrollTop={this.props.scrollTop}
                                        xmlKey={flight[0].xmlKey}
                                    />
                                </div>
                            );
                        } else if (flight.length > 1) {
                            tuple = (
                                <div className={classes.ContainersClubbed}
                                style={{ animationDelay: `${index * 0.4}s` }}
                                key={index}>
                                    <OneWayClubbed
                                        type="oneWay"
                                        flight={flight}
                                        flightSchedule={flight[0].OD}
                                        fareDetails={flight[0].FD.O}
                                        index={index}
                                        key={index}
                                        date={this.props.departDate}
                                        scrollTop={this.props.scrollTop}
                                        airlineNames={this.props.airlineNames}
                                        />
                                    </div>
                            ); 
                        }
                    return tuple;
                });
            }
        }

    return (
        <React.Fragment>
                { !this.props.desktopFilters ? <FlightHeader type={this.props.type}/> : null }
                {!this.props.loading && this.props.error ? <div className={classes.ErrorBox}>
              <div className="mb-4">
                <img src={errorImage} className="u-width100Percent" alt="Error" />
              </div>
              <HeadingH3 size={16} weight="Medium" color="Dark">No flights found.</HeadingH3>
              <p className="mt-3 mb-3">Sorry, There were no flights found for this route and date combination. We suggest you modify your search and try again.</p>
            </div> : <React.Fragment>
                    <div className={`u-phoneHide`} style={{marginRight: '-3.25rem', marginLeft: '-3.25rem'}}>
                    <AnimakitExpander
                        expanded={this.props.desktopFilters}
                        duration={500}
                        align="top">
                        <div className={`mb-4`}>
                            <Filters />
                        </div>
                    </AnimakitExpander>
                </div>
                {
                    (this.props.type === "R" || this.props.type === "O") ? <div className={classes.TabDetail}>
                        { this.props.headerView === 'filter' && !this.props.desktopFilters ? <Filters/> : null }
                    </div> : null
                }
                { this.props.type === "O" ? <div className={`pt-3 pb-3 u-backgroundColorWhite u-phoneShow phone-mb-4`} style={{ marginLeft: '-1rem', marginRight: '-1rem' }}>
                    <FlightHeaderQuickFilters/>
                </div> : null }
                { !this.props.desktopFilters && this.props.headerView !== 'filter' ? <FlightTupleHeader type={this.props.type} /> : null }
                {
                    !this.props.barLoading && (this.props.domOneWayFlights.length || this.props.totalResultsRound === 0) === 0 ? 
                        <div className={`u-absolute u-top50Percent u-left50Percent u-transformXYNegative50Percent`}>   
                            <div className={`mb-2`}>
                                <Illustrations type='empty-filter'/>
                            </div>
                            <div className={`u-textAlignCenter`}>
                                <div className={`mb-3`}>
                                    <HeadingH2 size={26} weight="Regular" color="Dark">Opps! No results are available.</HeadingH2>
                                </div>
                                <div className={`mb-4`}>
                                    <HeadingH3 size={13} weight="Regular" color="Light">We coudn't find flights to match your filters. Try changing the filters, or reset them.</HeadingH3>
                                </div>
                                <div className={`u-flex justify-content-center`}>
                                    <div className={`mr-1`}>
                                        <Button theme='Primary' type='Filter'>Undo Last</Button>
                                    </div>
                                    <div className={`ml-1`}>
                                        <Button theme='OutlinePrimary' type='Filter'>Clear All</Button>
                                    </div>  
                                </div>
                            </div>
                        </div> : this.props.loading && !this.props.error  ? <div>
                        <Spinner/>
                        <Loader type='flight'/>
                    </div> : 
                    this.props.flightType === 'DOM' ? this.props.type === "O" ? 
                        <ReactCSSTransitionGroup 
                            component='div'
                            transitionName='flip'
                            transitionAppear={true}
                            transitionEnter={false}
                            transitionLeave={false}
                            transitionAppearTimeout={3000}>
                            { oneWayDomesticFlights }
                        </ReactCSSTransitionGroup> : roundTripDomesticFlights : 
                    this.props.flightType === 'INT' ? this.props.type === "O" ? 
                        <ReactCSSTransitionGroup 
                            component='div'
                            transitionName='flip'
                            transitionAppear={true}
                            transitionEnter={false}
                            transitionLeave={false}
                            transitionAppearTimeout={3000}>
                            { oneWayInternationalFlights }
                        </ReactCSSTransitionGroup> : roundTripInternationalFlights : null
                }
                <Media query="(min-width: 1200px)">
                    {matches => 
                        matches ? (
                            <ReactCSSTransitionGroup
                                component={this.FirstChildHandler}
                                transitionName="move-right"
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}
                                transitionAppearTimeout={1000}>
                                { this.props.isDepartFlight && this.props.isReturnFlight && this.props.flightType === 'INT' ? <FlightDetailsRoundTrip proceedToBook={this.proceedToBook} /> : null }
                            </ReactCSSTransitionGroup>
                        ) : null}
                </Media>
                <Media query="(max-width: 599px)">
                    {matches => 
                        matches ? (
                            <ReactCSSTransitionGroup
                                component={this.FirstChildHandler}
                                transitionName="move-right"
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}
                                transitionAppearTimeout={1000}>
                                { this.props.isDepartFlight && this.props.isReturnFlight && this.props.flightType === 'INT' && this.props.mobileFlightDetail ? <FlightDetailsRoundTrip proceedToBook={this.proceedToBook} /> : null }
                            </ReactCSSTransitionGroup>
                        ) : null}
                </Media>
                </React.Fragment>}    
        </React.Fragment>
        );
    }
} 
    
const mapStateToProps = state => {
    return {
        loading: state.flights.loading,
        barLoading: state.flights.barLoading,
        headerView: state.ui.headerView,
        departDate: state.flights.departDate,
        domOneWayFlights: state.flights.dom.oneWayFlightsCombined,
        totalResultsRound: state.flights.dom.roundTripFlights.roundTripOnward.length + state.flights.dom.roundTripFlights.roundTripReturn.length,
        totalResultsOneWay: state.flights.dom.oneWayFlightsSingle.length,
        roundTripFlights: state.flights.int.roundTripFlights,
        intDepart: state.flights.int.intRoundTripDepart,
        intReturn: state.flights.int.intRoundTripReturn,
        intOneWayFlights: state.flights.int.oneWayFlightsCombined,
        airlineNames: state.flights.airlineNames,
        isDepartFlight: state.roundTripSummary.isDepartFlight,
        isReturnFlight: state.roundTripSummary.isReturnFlight,
        desktopFilters: state.ui.desktopFilters,
        calendarError: state.lowestFare.error,
        error: state.flights.error,
        tupleIndex: state.roundTripSummary.intIndex,
        searchId: state.flights.searchId,
        flightCode: state.flights.flightCode,
        mobileFlightDetail: state.ui.mobileFlightDetail,
        flightsNotFound: state.flights.flightsNotFound
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        onSetStackFlight: (flightSchedule, fareDetails, date, supplierCode, flightId, flightType) => dispatch(stackFlightActions.setStackFlight(flightSchedule, fareDetails, date, supplierCode, flightId, flightType)),
        onClearPax: () => dispatch(farePriceActions.clearPax())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Flight));


// WEBPACK FOOTER //
// ./src/components/Flight/Flight/Flight.js